export default "__VITE_ASSET__BefdnScu__"